<template>
  <div class="property"
       v-if="fieldProp.type">
    <!-- 为了适配所有字段的动态属性，有一些为罗列属性，可以提取为配置文件或配置属性 -->
    <div class="prop item">
      <span class="title">字段</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.fieldName"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="typeList.length > 0">
      <span class="title">字段类型</span>
      <el-radio class="margin10"
                v-for="(item, index) in typeList"
                :key="index"
                v-model="fieldProp[typeMap[fieldProp.type]]"
                :label="item.type">{{ item.value }}</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 3">
      <span class="title">单位</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.unit"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 3">
      <span class="title">单位位置</span>
      <el-radio class="margin10"
                v-model="fieldProp.unitPosition"
                :label="1">前缀</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
      <el-radio class="margin10"
                v-model="fieldProp.unitPosition"
                :label="2">后缀</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 3">
      <span class="title">保留几位小数</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.fixed"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 3">
      <span class="title">位数分割符</span>
      <el-select class="margin10"
                 v-model="fieldProp.separator">
        <!-- :disabled="!!fieldProp.fieldCode" -->
        <el-option v-for="item in breakList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="prop item"
         v-if="fieldProp.type <= 4">
      <span class="title">默认值</span>
      <el-select class="margin10"
                 v-model="fieldProp.default">
        <!-- :disabled="!!fieldProp.fieldCode" -->
        <el-option v-for="item in defaultList"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value"></el-option>
      </el-select>
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 5">
      <span class="title">选项方式</span>
      <el-radio class="margin10"
                v-model="fieldProp.showType"
                :label="1">下拉</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
      <el-radio class="margin10"
                v-model="fieldProp.showType"
                :label="2">平铺</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 5">
      <span class="title">备选项</span>
      <template v-for="(opt, index) in optionList">
        <div :key="index"
             style="display: flex;
    justify-content: center;
    align-items: center;">
          <el-color-picker v-model="colorList[index]"
                           :key="'c'+index"
                           @change="changeColor"
                           :predefine="predefineColors">
          </el-color-picker>
          <el-input class="margin10 width90"
                    v-model="optionList[index]"
                    :key="index">
            <!-- :disabled="!!fieldProp.fieldCode" -->
            <el-button slot="suffix"
                       type="text"
                       class="el-icon-delete"
                       @click.stop="deleteOption(index)"></el-button>
          </el-input>
        </div>
      </template>
      <el-button type="text"
                 class="margin10"
                 icon="el-icon-plus"
                 @click="addOption()">添加</el-button>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 6">
      <span class="title">输入限制</span>
      <el-radio class="margin10"
                v-model="fieldProp.limit"
                :label="1">不限制输入位置</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
      <el-radio class="margin10"
                v-model="fieldProp.limit"
                :label="2">通过固定地点限制</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
      <el-radio class="margin10"
                v-model="fieldProp.limit"
                :label="3">通过其他位置字段限制</el-radio>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 6">
      <span class="title">指定地点</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.position"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 6">
      <span class="title">地点周边范围</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.nearby"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type <= 2 && fieldProp.default === 2">
      <span class="title">指定文本</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.value"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 3 && fieldProp.default === 2">
      <span class="title">指定数值</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.value"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 4 && fieldProp.default === 3">
      <span class="title">指定日期</span>
      <!-- <el-input class="margin10 width90" v-model="fieldProp.assignDate"></el-input> -->
      <el-date-picker class="margin10 width90"
                      :type="fieldProp.dateType === 1 ? 'date' : 'datetime'"
                      v-model="fieldProp.assignDate"></el-date-picker>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 10">
      <span class="title">消息模板</span>
      <div class="mt10 mb10">
        <!-- :disabled="!!fieldProp.fieldCode" -->
        <notice-field v-model="fieldProp.extendInfo"
                      :modelContent="modelContent"
                      :smsMessages="smsMessages"
                      :appMessages="appMessages"
                      :wxMessages="wxMessages"></notice-field>
      </div>
    </div>
    <div class="prop item"
         v-if="fieldProp.type === 10">
      <span class="title">发送时机</span>
      <el-radio-group v-model="fieldProp.sendMoment">
        <!-- :disabled="!!fieldProp.fieldCode" -->
        <el-radio class="margin10"
                  :label="1">创建时发送</el-radio>
        <el-radio class="margin10"
                  :label="2">完成后发生</el-radio>
      </el-radio-group>
    </div>
    <div class="prop item">
      <span class="title">设置</span>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.scan"
                   v-model="fieldProp.scan"
                   :true-label="1"
                   :false-label="0">仅可扫码输入</el-checkbox>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.required"
                   v-model="fieldProp.required"
                   @change="setRequired"
                   :true-label="1"
                   :false-label="0">必填</el-checkbox>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.unique"
                   v-model="fieldProp.unique"
                   :true-label="1"
                   :false-label="0">唯一</el-checkbox>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.search"
                   v-model="fieldProp.search"
                   :true-label="1"
                   :false-label="0">精确匹配</el-checkbox>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.week"
                   v-model="fieldProp.week"
                   :true-label="1"
                   :false-label="0">显示星期几</el-checkbox>
      <el-checkbox class="margin10"
                   v-if="'undefined' !== typeof fieldProp.showMap"
                   v-model="fieldProp.showMap"
                   :true-label="1"
                   :false-label="0">显示地图</el-checkbox>
    </div>
    <div class="prop item">
      <span class="title">提示信息</span>
      <el-input class="margin10 width90"
                v-model="fieldProp.placeholder"></el-input>
      <!-- :disabled="!!fieldProp.fieldCode" -->
    </div>
  </div>
</template>

<script>
import { api } from "../api";
import noticeField from './notice-field.vue'
export default {
  components: {
    noticeField
  },
  name: "field-props",
  model: {
    prop: "fieldProp",
    event: "handleReturn",
  },
  props: {
    workOrderType: {
      type: [Number, String],
      default: () => {
        return -1;
      }
    },
    fieldProp: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    currentField () {
      let list = [];
      switch (this.fieldProp.type) {
        case 1:
          list = [
            { type: 1, value: "单行" },
            { type: 2, value: "多行" },
          ];
          break;

        case 3:
          list = [
            { type: 1, value: "数值" },
            { type: 2, value: "金额" },
            { type: 3, value: "百分比" },
          ];
          break;

        case 4:
          list = [
            { type: 1, value: "仅日期" },
            { type: 2, value: "日期和时间" },
          ];
          break;

        case 5:
          list = [
            { type: 1, value: "单选项" },
            { type: 2, value: "多选项" },
          ];
          break;

        case 6:
          list = [
            { type: 1, value: "仅可获取当前位置" },
            { type: 2, value: "可搜索指定位置" },
          ];
          break;

        default:
          break;
      }
      return {
        list: list,
      };
    },
    typeList () {
      return this.currentField.list;
    },
    defaultList () {
      if (this.fieldProp.type <= 2) {
        return this.textList;
      } else if (this.fieldProp.type === 3) {
        return this.numberList;
      } else if (this.fieldProp.type === 4) {
        return this.dateList;
      }
      return this.textList;
    },
  },
  watch: {
    fieldProp: {
      handler (newVal) {
        this.field = newVal;
        if (newVal.type === 5) {
          //this.optionList = newVal.optionName.split("|");
          this.optionList = newVal.valueList
          this.colorList = newVal.colorList
        }
        if (newVal.type === 10) {
          this.computedMessage();
        }
      },
      deep: true,
      immediate: true
    },
    field (newVal) {
      this.field = newVal;
      this.$emit("handleReturn", this.field);
    },
    optionList (newVal) {
      this.optionList = newVal;
      //this.fieldProp.optionName = newVal.join("|");
      let newList = newVal.map((el, index) => {
        return el + ':' + this.colorList[index]
      })
      this.fieldProp.optionName = newList.join("|");
    },
    workOrderType (newVal) {
      if (newVal !== -1) {
        this.querySmsTemplate();
      }
    }
  },
  data () {
    return {
      colorList: [],
      field: {},
      // '#13C9B7',
      predefineColors: [
        '#FE713A',
        '#ff8c00',
        '#ffd700',
        '#24A69A',
        '#63BA6B',
        '#586CBB',
        '#1e90ff',
        '#c71585',
        '#EA41DE',
        '#B0B0B0'
      ],
      typeMap: {
        1: "rowType",
        3: "numberType",
        4: "dateType",
        5: "selectType",
        6: "inputType",
      },
      optionList: [],
      breakList: [
        {
          value: 1,
          label: "不显示",
        },
        {
          value: 2,
          label: "千分位",
        },
        {
          value: 3,
          label: "万分位",
        },
      ],
      textList: [
        {
          value: 1,
          label: "无",
        },
        {
          value: 2,
          label: "指定文本",
        },
      ],
      numberList: [
        {
          value: 1,
          label: "无",
        },
        {
          value: 2,
          label: "指定数值",
        },
      ],
      dateList: [
        {
          value: 0,
          label: "无",
        },
        {
          value: 1,
          label: "当天日期",
        },
        {
          value: 2,
          label: "下一天日期",
        },
        {
          value: 3,
          label: "指定日期",
        },
      ],
      modelContent: {},
      smsMessages: [],
      appMessages: [],
      wxMessages: []
    };
  },
  mounted () {
    // 消息通知类型与后台定义的消息类型对应配置
    this.messageTypeMap = {
      // 1为App信息通知，对应的后台消息类型为4
      1: 4,
      // 2为短信通知，对应的后台消息类型为3
      2: 3,
    };
  },
  methods: {
    changeColor (color) {
      let newList = this.optionList.map((el, index) => {
        if (this.colorList[index] != null) {
          return el + ':' + this.colorList[index]
        } else {
          return el + ':'
        }
      })
      this.fieldProp.optionName = newList.join("|");
    },
    setRequired (e) {
      let messageInfo = (this.fieldProp.extendInfo || {});
      // 如果当前字段是消息通知类型，如果用户需要设置必填，则需要判断当前是否有选中消息通知模板，如未选择，则提示用户选择消息通知模板
      if (this.fieldProp.type === 10 && e === 1) {
        if (!messageInfo.sms.messageModel && !messageInfo.appMsg.messageModel && !messageInfo.wxMsg.messageModel) {
          this.$message.warning("请至少选择一个消息通知模板");
          this.fieldProp.required = 0;
        }
      }
    },
    computedMessage () {
      let messageInfo = (this.fieldProp.extendInfo || {});
      if (!messageInfo.sms.messageModel && !messageInfo.appMsg.messageModel && !messageInfo.wxMsg.messageModel) {
        this.fieldProp.required = 0;
      }
      // if (messageInfo.sms.checked && !messageInfo.sms.messageModel) {
      //   this.$message.warning("请选择短信模板");
      //   return;
      // }
      // if (messageInfo.appMsg.checked && !messageInfo.appMsg.messageModel) {
      //   this.$message.warning("请选择App消息模板");
      //   return;
      // }
      // if (messageInfo.wxMsg.checked && !messageInfo.wxMsg.messageModel) {
      //   this.$message.warning("请选择微信公众号消息模板");
      //   return;
      // }
      let messageValue = [];
      if (messageInfo.sms.messageModel) {
        messageValue.push('3-' + messageInfo.sms.messageModel + '-' + messageInfo.sms.messageContent);
      }
      if (messageInfo.wxMsg.messageModel) {
        messageValue.push('4-' + messageInfo.wxMsg.messageModel + '-' + messageInfo.wxMsg.messageContent);
      }
      if (messageInfo.appMsg.messageModel) {
        messageValue.push('5-' + messageInfo.appMsg.messageModel + '-' + messageInfo.appMsg.messageContent);
      }
      this.fieldProp.messageInfo = messageValue.join('|');
    },
    // 查询短信模板
    querySmsTemplate () {
      // 消息通知类型与后台定义的消息类型对应配置
      let messageTypeMap = {
        // 短信通知，对应的后台消息类型为3
        sms: 3,
        // App信息通知，对应的后台消息类型为5
        app: 5,
        // 微信公众号通知消息，对应的后台消息类型为4
        wx: 4,
      };
      // workOrderType 工单类型，1：巡检工单，2：超速罚单，3：车辆违规罚单，4：维修工单
      // type 类型，1：工单表格，2：工单
      this.$fetch(api.workOrder.queryWorkOrderNoticeTemplate, {
        workOrderType: this.workOrderType,
        type: 1,
      }).then((response) => {
        if (response && response.success) {
          const modelsList = response.returnObj;
          if (modelsList && modelsList.length) {
            this.modelContent = {};
            modelsList.forEach((item) => {
              // 如果当前通知消息体是微信公众号消息模板，则是一个JSON字符串，需要将JSON字符串转换成具体的消息
              this.modelContent[
                item.noticeTemplateCode
              ] = this.buildTemplateContent(item.templateContent);
              if (item.templateType === messageTypeMap.app) {
                this.appMessages.push(item);
              } else if (item.templateType === messageTypeMap.sms) {
                this.smsMessages.push(item);
              } else if (item.templateType === messageTypeMap.wx) {
                this.wxMessages.push(item);
              }
            });
          }
        } else {
          this.$message.warning(response.msgContent);
        }
      });
    },
    buildTemplateContent (str) {
      let result = '';
      if (typeof str === "string" && (str.indexOf('{') === 0 || str.indexOf('[') === 0)) {
        // 去掉字符串中的单引号
        str = str.replace(/'/g, "");
        try {
          let obj = JSON.parse(str);
          if (obj.data) {
            for (let key in obj.data) {
              result += key + ":" + obj.data[key].value + '\n';
            }
          }
          if (result === '') {
            result = str;
          }
        } catch (e) {
          console.log(e);
          result = str;
        }
      } else {
        result = str;
      }
      return result;
    },
    addOption () {
      const length = this.optionList.length;
      this.$set(this.optionList, length, "");
      this.$set(this.colorList, length, "");
    },
    deleteOption (index) {
      this.optionList.splice(index, 1);
      this.colorList.splice(index, 1);
    },
  },
};
</script>

<style>
</style>